import React from "react";
import cc from "currency-codes";
import ccData from "currency-codes/data";
import moment from "moment";

import GatewayRates from "./rates/GatewayRates";
import AddRatesModal from "./rates/AddRatesModal";
import EditRatesModal from "./rates/EditRatesModal";
import ManageRateUpdateModal from "./rates/ManageRateUpdateModal";
import ScheduleRateUpdateModal from "./rates/ScheduleRateUpdateModal";

import Util from "../../libs/util";
import Swal from "sweetalert2";
import {
	removeResellerRateUpdate,
	getResellerPaymentGatewayUpdate,
} from "../../libs/functions";

const ratesUpdateTabs = ["Scheduled", "Completed"];

class ManageRateModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			addRatesPayload: {},
			editRatesPayload: {},
			ratesUpdateTab: "Scheduled",
			scheduleRateUpdatePayload: {},
			manageRateUpdatePayload: {},
		};

		this.gatewayPriority = ["tctp", "uqpay", "ipay88"];
	}

	getRateGateway = (mdr) => {
		if (mdr) {
			return Object.keys(mdr).sort((a, b) => {
				return (
					this.gatewayPriority.indexOf(a) < this.gatewayPriority.indexOf(b)
				);
			});
		} else return [];
	};

	getRateCurrencies = (rates) => {
		if (rates) {
			return Object.keys(rates)
				.map((i) => cc.number(i).code)
				.sort((a, b) => {
					if (a === "SGD") return -1;
					else if (b === "SGD") return 1;
					else return 0;
				});
		} else return [];
	};

	renderGatewayTabs = (mdr) => {
		const gateways = this.getRateGateway(mdr);
		if (gateways.length > 0)
			return (
				<ul uk-tab="connect: #rates-table">
					{gateways.map((g) => (
						<li key={`mdr-${g}`}>
							<a className="mdr-gateway-tab">
								<img
									className="uk-img"
									src={`data:image/*;base64,${this.props.gateway[g].image}`}
									width="50"
								/>
								<button
									className="uk-margin-left uk-icon-button uk-button-primary"
									uk-icon="icon: fa-solid-plus-circle; ratio: 0.5"
									type="button"
									onClick={() => this.openAddRates(g)}
								/>
							</a>
						</li>
					))}
				</ul>
			);
	};

	renderGatewayRates = (mdr, reseller) => {
		const gateways = this.getRateGateway(mdr);
		if (gateways.length > 0)
			return (
				<ul id="rates-table" className="uk-switcher">
					{gateways.map((g) => (
						<GatewayRates
							key={`rates-${g}`}
							gateway={g}
							rates={mdr[g]}
							reseller={reseller}
							MDRTypes={this.props.MDRTypes}
							openEditRates={this.openEditRates}
							openScheduleRateUpdate={this.openScheduleRateUpdate}
							refreshRates={this.props.refreshRates}
						/>
					))}
				</ul>
			);
	};

	renderRateUpdate = (rateUpdates, type) => {
		const { gateway } = this.props;
		return (
			<li>
				{rateUpdates && rateUpdates.length > 0 && (
					<table className="uk-table uk-table-striped uk-table-middle uk-margin-top uk-margin-remove-bottom">
						<thead>
							<tr>
								<th className="uk-width-1-4">Gateway</th>
								<th className="uk-width-1-4">Currency</th>
								<th className="uk-width-1-4">
									{type === "Scheduled" ? "Effective At" : "Completed At"}
								</th>
								<th className="uk-width-1-4">Rates</th>
							</tr>
						</thead>
						<tbody>
							{rateUpdates.map((i) => (
								<tr key={i._id}>
									<td className="uk-width-1-4">
										<img
											className="uk-img"
											src={`data:image/*;base64,${
												gateway[i.paymentGateway].image
											}`}
											width="50"
										/>
									</td>
									<td className="uk-width-1-4">{cc.number(i.currency).code}</td>
									<td className="uk-width-1-4">
										{moment(
											type === "Scheduled" ? i.effectiveDate : i.completedAt
										).format("DD MMM YYYY")}
									</td>
									<td className="uk-width-1-4">
										<button
											className="uk-icon-button uk-button-primary"
											uk-icon="icon: fa-solid-cog; ratio: 0.5"
											type="button"
											onClick={() => this.openManageRateUpdate(i)}
										/>
										{type === "Scheduled" && (
											<button
												className="uk-margin-left uk-icon-button uk-button-danger"
												uk-icon="icon: fa-solid-trash; ratio: 0.5"
												type="button"
												onClick={() => this.removeRateUpdate(i._id)}
											/>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</li>
		);
	};

	openAddRates = (g) => {
		const {
			details: { reseller, mdr },
			gateway,
			MDRTypes,
		} = this.props;

		const usedCC = this.getRateCurrencies(mdr[g]);

		const addRatesPayload = {
			reseller: reseller,
			gateway: { name: g, label: gateway[g].name },
			availableCC: ccData.filter((i) => !usedCC.includes(i.code)),
			MDRTypes,
		};

		this.setState({ addRatesPayload }, async () => {
			await Util.showModal("add-reseller-rates");
		});
	};

	openEditRates = (g, currency) => {
		const {
			details: { reseller, mdr },
			gateway,
			MDRTypes,
		} = this.props;

		const editRatesPayload = {
			reseller,
			gateway: { name: g, label: gateway[g].name },
			currency: { code: cc.number(currency).code, number: currency },
			rates: mdr[g][currency],
			MDRTypes,
		};

		this.setState({ editRatesPayload }, async () => {
			await Util.showModal("edit-reseller-rates");
		});
	};

	openScheduleRateUpdate = (g, currency) => {
		const {
			details: { reseller },
			gateway,
			MDRTypes,
		} = this.props;

		const scheduleRateUpdatePayload = {
			reseller,
			gateway: { name: g, label: gateway[g].name },
			currency: { code: cc.number(currency).code, number: currency },
			MDRTypes,
		};

		this.setState({ scheduleRateUpdatePayload }, async () => {
			await Util.showModal("schedule-reseller-rates");
		});
	};

	openManageRateUpdate = (rateUpdate) => {
		const { paymentGateway, currency, rates, effectiveDate, completedAt } =
			rateUpdate;
		const {
			details: { reseller },
			gateway,
			MDRTypes,
		} = this.props;

		const manageRateUpdatePayload = {
			reseller,
			gateway: { name: paymentGateway, label: gateway[paymentGateway].name },
			currency: { code: cc.number(currency).code, number: currency },
			rates,
			effectiveDate,
			canEdit: completedAt === undefined,
			MDRTypes,
		};

		this.setState({ manageRateUpdatePayload }, async () => {
			await Util.showModal("manage-reseller-rate-update");
		});
	};

	closeManageRateUpdate = () => {
		this.setState({ manageRateUpdatePayload: {} }, async () => {
			await Util.hideModal("manage-reseller-rate-update");
		});
	};

	removeRateUpdate = (updateId) => {
		Swal.fire({
			title: "Removing rate update",
			onBeforeOpen: () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { status } = await removeResellerRateUpdate({
						_id: updateId,
					});
					if (status === "success") {
						Swal.fire({
							icon: "success",
							title: "Rate update removed!",
						}).then(async () => {
							await this.props.refreshRates();
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to remove rate update`,
						onClose: () => {},
					});
				}
			},
		});
	};

	resellerPaymentGatewayUpdate = () => {
		const { details } = this.props;
		// console.log("details", details);
		const resellerID = details.reseller._id;
		// console.log("resellerID", resellerID);
		Swal.fire({
			title: "Update Payment Gateway",
			onBeforeOpen: () => {
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { status } = await getResellerPaymentGatewayUpdate(resellerID);
					console.log("Status update", status);
					if (status === "success") {
						Swal.fire({
							icon: "success",
							title: "Payment Gateway Update",
						}).then(async () => {
							await this.props.refreshRates();
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to Payment Gateway Update`,
						onClose: () => {},
					});
				}
			},
		});
	};

	render() {
		const {
			addRatesPayload,
			editRatesPayload,
			ratesUpdateTab,
			manageRateUpdatePayload,
			scheduleRateUpdatePayload,
		} = this.state;
		const { details, targetRateUpdates, refreshRates } = this.props;
		const { reseller, mdr } = details;
		const { scheduled, completed } = targetRateUpdates;

		return (
			<>
				<div id="manage-rates" className="uk-modal-full" uk-modal="">
					<div className="uk-modal-dialog">
						<button
							className="uk-modal-close-full uk-close-large"
							type="button"
							uk-close=""
						/>
						<div className="uk-padding">
							<h3>
								<span className="uk-flex uk-flex-middle">
									<i
										className="uk-margin-small-right form-header-icon"
										uk-icon="icon: fa-solid-cogs"
									/>
									Manage Rates for {reseller?.name}
								</span>
								<button
									className="uk-button uk-button-small uk-button-primary action-btn"
									type="button"
									onClick={() => this.resellerPaymentGatewayUpdate()}
								>
									<span className="uk-text-middle uk-text-bold">
										Update Payment Gateway
									</span>
								</button>
							</h3>
							<div className="uk-margin-top uk-flex">
								<div className="uk-width-3-5 uk-padding-small uk-padding-remove-left uk-padding-remove-vertical">
									<h4 className="uk-margin-remove">
										<span className="uk-flex uk-flex-middle">
											<i
												className="uk-margin-small-right form-header-icon"
												uk-icon="icon: fa-solid-info-circle; ratio: 0.9"
											/>
											Current Rates{" "}
											<span class="uk-label reseller-rates-tag">
												{reseller?.commissionType === "base" ||
												reseller?.accessControlType === "master"
													? "Base"
													: "Custom"}
											</span>
										</span>
										<hr className="uk-margin-small-top uk-margin-small-bottom" />
									</h4>
									{this.renderGatewayTabs(mdr)}
									{this.renderGatewayRates(mdr, reseller)}
								</div>
								<div className="uk-width-2-5 uk-padding-small uk-padding-remove-right uk-padding-remove-vertical">
									<h4 className="uk-margin-remove">
										<span className="uk-flex uk-flex-middle">
											<i
												className="uk-margin-small-right form-header-icon"
												uk-icon="icon: fa-solid-wrench; ratio: 0.9"
											/>
											Rates Updates
										</span>
										<hr className="uk-margin-small-top uk-margin-small-bottom" />
									</h4>
									<div uk-switcher="connect: #rates-update-table;animation: uk-animation-fade; toggle: > *">
										{ratesUpdateTabs.map((i) => (
											<button
												key={i}
												className={`uk-button uk-button-default action-btn uk-margin-right ${
													i === ratesUpdateTab ? "uk-active" : ""
												}`}
												type="button"
											>
												<span className="uk-text-bold">{i}</span>
											</button>
										))}
									</div>
									<ul id="rates-update-table" className="uk-switcher uk-margin">
										{this.renderRateUpdate(scheduled, "Scheduled")}
										{this.renderRateUpdate(completed, "Completed")}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<AddRatesModal payload={addRatesPayload} refreshRates={refreshRates} />
				<EditRatesModal
					payload={editRatesPayload}
					refreshRates={refreshRates}
				/>
				<ManageRateUpdateModal
					payload={manageRateUpdatePayload}
					// closeModal={this.closeManageRateUpdate}
					refreshRates={refreshRates}
				/>
				<ScheduleRateUpdateModal
					payload={scheduleRateUpdatePayload}
					refreshRates={refreshRates}
				/>
			</>
		);
	}
}

export default ManageRateModal;
